import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import {adminMainUrl} from '../../../../Config'
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../../Config';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

const DataExport = ({ accessedModules, accessedPermission }) => {

const columns = [
{ title: "Title", dataIndex: "currencyName", key: "currencyName" },
{ title: "Location", dataIndex: "code", key: "code" },
{ title: "Submitted On", dataIndex: "forExport", key: "forExport" },
{ title: "Status", dataIndex: "forImport", key: "forImport" },

];

const data = [
{
key: "1",
currencyName: "US Dollar",
code: "USD",

},
];

return (
<>
    <div className="page-wrapper">
        <div className="content">
            <div className="row">
                <div className="col-md-12">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">
                                    Data Export<span className="count-title">3</span>
                                </h4>

                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    <a href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-original-title="Collapse" id="collapse-header">
                                        <i className="ti ti-chevrons-up" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}
                </div>
            </div>
            <div className="card">

                <div className="card-body">
                    <div className="row">
                    <div className="row d-flex align-items-center pb-2">
  <label htmlFor="consoleType" className="me-2" style={{ width: "auto" }}>Export</label>
  <select className="form-control form-control-sm ms-1" id="consoleType" style={{ width: "40%" }}>
    <option value="ALL">Data</option>
    <option value="1">Master</option>
  </select>
</div>


                        <div className="col-md-6">
                            <p className='ps-2'
                                style={{ backgroundColor: '#F3EDFF', color: '#4A00E5', fontSize: '16px' }}>
                                Data Filter:
                            </p>

                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0">Period</label>
                                <div className="icon-forms mb-3">
                                    <input type="date" id="effectiveFrom" className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0">Transaction</label>
                                <div className="icon-forms mb-3">
                                    <Select className="custom-selector ms-2 w-100" name="" placeholder="All" />
                                </div>
                            </div>
                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0">Sub Type</label>
                                <div className="icon-forms mb-3">
                                    <Select className="custom-selector ms-2 w-100" name="" placeholder="All" />
                                </div>
                            </div>
                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0"> Type</label>
                                <div className="icon-forms mb-3">
                                    <Select className="custom-selector ms-2 w-100" name="" placeholder="Select" />
                                </div>
                            </div>
                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0"> Sort On</label>
                                <div className="icon-forms mb-3">
                                    <Select className="custom-selector ms-2 w-100" name="" placeholder="Date" />
                                </div>
                            </div>
                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0"> Locations</label>
                                <div className="icon-forms mb-3">
                                    <Select className="custom-selector ms-2 w-100" name="" placeholder="Delhi" />
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-start ">

                            <p className='ps-2'
                                style={{ backgroundColor: '#F3EDFF', color: '#4A00E5', fontSize: '16px' }}>
                                Settings:
                            </p>
                            <div className="col-md-12 ms-2 me-2">
                                <div className="col-md-12 d-flex row align-items-baseline mb-3 w-100">
                                    <label htmlFor="currency" className="col-form-label col-4 mb-0">Currency</label>
                                    <div className="icon-forms col-8 d-flex flex-row">
                                        <input type="checkbox" id="currency" className="form-check-input" />
                                        <label htmlFor="currency" className="form-check-label ms-2">Export in transacted
                                            currency</label>
                                    </div>
                                </div>

                                <div className="col-md-12 d-flex row align-items-baseline mb-3 w-100">
                                    <label htmlFor="billing" className="col-form-label col-4 mb-0">Billing</label>
                                    <div className="icon-forms col-8 d-flex flex-row">
                                        <input type="checkbox" id="billing" className="form-check-input"
                                            defaultChecked />
                                        <label htmlFor="billing" className="form-check-label ms-2">Export the posted
                                            G/Ls</label>
                                    </div>
                                </div>

                                <div className="col-md-12 d-flex row align-items-baseline mb-3 w-100">
                                    <label htmlFor="invoice" className="col-form-label col-4 mb-0">Invoice</label>
                                    <div className="icon-forms col-8 d-flex flex-row">
                                        <input type="checkbox" id="invoice" className="form-check-input"
                                            defaultChecked />
                                        <label htmlFor="invoice" className="form-check-label ms-2">Allocate Bill Nos as
                                            &lt;New Ref&gt;</label>
                                    </div>
                                </div>

                                <div className="col-md-12 d-flex row align-items-baseline mb-3 w-100">
                                    <label htmlFor="vouchers1" className="col-form-label col-4 mb-0">Vouchers</label>
                                    <div className="icon-forms col-8 d-flex flex-row">
                                        <input type="checkbox" id="vouchers1" className="form-check-input"
                                            defaultChecked />
                                        <label htmlFor="vouchers1" className="form-check-label ms-2">Allocate Job Nos as
                                            &lt;New Ref&gt;</label>
                                    </div>
                                </div>

                                <div className="col-md-12 d-flex row align-items-baseline mb-3 w-100">
                                    <label htmlFor="vouchers2" className="col-form-label col-4 mb-0">Vouchers</label>
                                    <div className="icon-forms col-8 d-flex flex-row">
                                        <input type="checkbox" id="vouchers2" className="form-check-input"
                                            defaultChecked />
                                        <label htmlFor="vouchers2" className="form-check-label ms-2">Allocate Bill Nos
                                            as &lt;Agst Ref&gt;</label>
                                    </div>
                                </div>

                                <div className="col-md-12 d-flex row align-items-baseline mb-3 w-100">
                                    <label htmlFor="reExport" className="col-form-label col-4 mb-0">ReExport</label>
                                    <div className="icon-forms col-8 d-flex flex-row">
                                        <input type="checkbox" id="reExport" className="form-check-input" />
                                        <label htmlFor="reExport" className="form-check-label ms-2">Add Cost
                                            Centre</label>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    {/* Filter */}

                    {/* /Filter */}

                    {/* Contact List */}

                    {/* {
                    loadingDesignationTypeApi ?
                    arr.map((value, index) => {
                    return (

                    <div className='d-flex justify-content-center align-items-center'
                        style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                    </div>
                    )
                    }) :
                    spinnerLoader ?
                    <>
                        <div className='d-flex justify-content-center align-items-center'
                            style={{ height: "400px", width: "100%" }}>
                            <BeatLoader />
                        </div>
                    </> :
                    <> */}

                        {/*
                        <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset}
                            dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount}
                            setCurrentData={setCurrentData} currentData={currentData} />
                    </>
                    } */}
                    {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                        <button className='' onClick={()=> handlePageChange(count - 1)}
                            disabled={count === 1}
                            >
                            <img src="/img/right.png" className='mx-2' alt="right" />
                        </button>

                        {pageNumbers.map((number, index) =>
                        number === '...' ? (
                        <span key={index} className="mx-2">...</span>
                        ) : (
                        <span key={number} className={`search-btn-1 ${number===count ? 'active' : '' }`} onClick={()=>
                            handlePageChange(number)}
                            style={{ cursor: 'pointer' }}
                            >
                            {number}
                        </span>
                        )
                        )}

                        <button onClick={()=> handlePageChange(count + 1)}
                            disabled={count === totalPages}
                            >
                            <img src="/img/left.png" className='mx-2' alt="right" />
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
    {/*
    <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
    <EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
    {/*
    <EditEmployee id="offcanvas_edit" />
    <AddEmployee id="offcanvas_add" /> */}
    {/*
    <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />
    <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
</>

)
}

export default DataExport